import { render, staticRenderFns } from "./WorkPermitOption.vue?vue&type=template&id=fe6707b6&scoped=true"
import script from "./WorkPermitOption.vue?vue&type=script&lang=js"
export * from "./WorkPermitOption.vue?vue&type=script&lang=js"
import style0 from "./WorkPermitOption.vue?vue&type=style&index=0&id=fe6707b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6707b6",
  null
  
)

export default component.exports